import React from 'react';
import { styles } from './styles';
import { GridRowContainer } from "./GridRowContainer";
var GridRowCell = React.memo(function GridRowCell(props) {
    return (React.createElement("div", { className: styles.cell, style: {
            width: props.width,
            minWidth: props.width,
            maxWidth: props.width,
            flexBasis: props.width
        } }, props.renderer(props.payload)));
});
export function createGridRowRenderer(config) {
    return function renderGridRow(_a) {
        var index = _a.index, height = _a.height, width = _a.width, topOffset = _a.topOffset, data = _a.data, columns = _a.columns, className = _a.className, idGetter = _a.idGetter, handlers = _a.handlers, disabled = _a.disabled, inactive = _a.inactive;
        var rowDataItem = data[index];
        return React.createElement((config === null || config === void 0 ? void 0 : config.container) || GridRowContainer, {
            key: "row-" + idGetter(rowDataItem),
            className: className,
            disabled: disabled,
            inactive: inactive,
            style: {
                height: height,
                minHeight: height,
                maxHeight: height,
                minWidth: width,
                transform: "translateY(" + Math.round(topOffset) + "px)"
            },
            onClick: handlers === null || handlers === void 0 ? void 0 : handlers.onClick,
            onContextMenu: handlers === null || handlers === void 0 ? void 0 : handlers.onContextMenu,
            onDoubleClick: handlers === null || handlers === void 0 ? void 0 : handlers.onDoubleClick
        }, columns.map(function (colConfig, colIndex) {
            return (React.createElement(GridRowCell, { key: "cell-" + idGetter(rowDataItem) + "-" + colConfig.id, renderer: colConfig.cell, width: colConfig.width, payload: {
                    rowData: rowDataItem,
                    rowIndex: index,
                    cellIndex: colIndex,
                    column: colConfig,
                    disabled: disabled,
                    inactive: inactive
                } }));
        }));
    };
}
//# sourceMappingURL=createGridRowRenderer.js.map